// «Сегодня» (К-03): рекомендованный сценарий, «Играть с ребёнком», прогресс, гид.
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router";
import { ScenarioCard } from "../components/ScenarioCard.tsx";
import { TopBar } from "../components/Shell.tsx";
import { ageOf, playedScenarios, recommended } from "../lib/content/catalog.ts";
import { db, type StoredEvent } from "../lib/db.ts";
import { activeChild, refreshContent, useApp } from "../state/app.ts";
import { t, years } from "../i18n/ru.ts";

export function useChildEvents(childId: string | undefined): StoredEvent[] {
  const [ev, setEv] = useState<StoredEvent[]>([]);
  const statuses = useApp((s) => s.statuses);
  useEffect(() => {
    if (childId) void db.events.where("childId").equals(childId).toArray().then(setEv);
  }, [childId, statuses]);
  return ev;
}

export function Today() {
  const nav = useNavigate();
  const { content, contentState, contentError, progress, statuses, account } = useApp();
  const child = activeChild();
  const events = useChildEvents(child?.id);
  const [sessions, setSessions] = useState(0);
  useEffect(() => {
    void db.events.where("type").equals("kid_session_ended").count().then(setSessions);
  }, [events]);
  const rec = content && child ? recommended(content, child.stage, events) : undefined;
  const st = child ? statuses[child.id] ?? {} : {};
  const principles = content?.dictionaries.principles ?? {};
  return (
    <div className="page">
      <TopBar
        title={child ? t.today.hello(`${child.nickname}, ${years(ageOf(child.birthYear))}`) : t.app.name}
        actions={
          <Link className="icon-btn" to="/settings" aria-label={t.tabs.settings}>
            ⚙
          </Link>
        }
      />
      {contentState === "loading" || (!content && contentState !== "error") ? (
        <div className="card">
          <p>{t.today.noContent}</p>
          {progress ? <progress max={progress.total} value={progress.done} /> : null}
        </div>
      ) : null}
      {contentState === "error" && !content ? (
        <div className="card">
          <p>{contentError ?? t.today.contentError}</p>
          <button className="btn" onClick={() => void refreshContent()}>
            {t.common.retry}
          </button>
        </div>
      ) : null}
      {rec ? (
        <section className="today">
          <div className="today__main">
            <h2 className="section-title">{t.today.recommended}</h2>
            <ScenarioCard s={rec.scenario} played={playedScenarios(events).has(rec.scenario.scenario.id)} onOpen={() => nav(`/scenario/${encodeURIComponent(rec.scenario.scenario.id)}`)} />
            <div className="stack">
              <button className="btn btn--primary btn--big" onClick={() => nav("/kid")}>
                ▶ {t.today.playKid}
              </button>
              <button className="btn btn--big" onClick={() => nav(`/scenario/${encodeURIComponent(rec.scenario.scenario.id)}`)}>
                {t.today.watchSelf}
              </button>
            </div>
            <Link className="card link-card" to="/guide">
              📖 {t.today.guide}
            </Link>
          </div>
          <aside className="today__side">
            <h2 className="section-title">{t.today.week}</h2>
            <ul className="principles">
              {Object.entries(st).map(([code, s]) => (
                <li key={code}>
                  <span className={`dot dot--${s.status}`} aria-hidden="true" />
                  {principles[code]?.name ?? code} — {t.progress.statuses[s.status]}
                </li>
              ))}
              {!Object.keys(st).length ? <li className="muted">{t.progress.empty}</li> : null}
            </ul>
            {rec.scenario.scenario.after.askAfterTraining ? (
              <div className="callout">
                <strong>{t.today.askAfter}:</strong> «{rec.scenario.scenario.after.askAfterTraining}»
              </div>
            ) : null}
            {account.anonymous && sessions >= 3 ? (
              <Link className="callout" to="/settings#account">
                <strong>{t.today.saveProgress}</strong>
                <br />
                {t.today.saveProgressText}
              </Link>
            ) : null}
          </aside>
        </section>
      ) : null}
    </div>
  );
}
